module.exports = __webpack_public_path__ + "img/c194c55.jpg";